var hashTab = {
    hashTab: null,
    requestParams: {},
    /**
     * URL hash feldolgozás
     */
    stripHash : function() {
        this.hash = window.location.hash.replace('#/','');
        if(this.hash) {
            var e = this.hash.split(';');
            this.hashTab = e[0];
            var pE = e[1].split(',');
            this.requestParams = {
                page: pE[0].split('page:')[1],
                char: pE[1].split('char:')[1],
                /* lazyLoad: asyncTabs.lazyLoad, */
                limit: typeof pE[2] !== 'undefined' ?  pE[2].split('limit:')[1] : '',
                view: typeof pE[3] !== 'undefined' ?  pE[3].split('view:')[1] : '',
            };
            /*
            if(this.requestParams.limit && $('#limit option:selected').val() != this.requestParams.limit){
                $('#limit option:selected').removeAttr('selected');
                $('#limit option[value='+this.requestParams.limit+']').attr('selected','selected');
                $(".selectpicker").selectpicker('refresh');
            }
            */
        }
        //this.debugLog(this.requestParams);
    },
    /**
     * Hash frissítés
     *
     * @param {string} hashTab
     * @param {int} page
     * @param {string} char
     * @param {string} limit
     * @param {string} view
     */
    hashUpdate : function(page, char, hashTab, limit, view) {
        if(hashTab === undefined) {
            hashTab = this.hashTab;
        }
        if(typeof page === 'undefined'){
            page = 0;
        }
        if(typeof char === 'undefined'){
            char = '';
        }
        if(typeof limit === 'undefined'){
            limit = ''
        }
        if(typeof view === 'undefined'){
            view = 'grid'
        }
        var hash = '#/' + hashTab + ';page:' + page.toString() + ',char:'+char.toString()+',limit:'+limit;

        if(view){
            hash += ',view:'+view.toString();
        }

        window.location.hash = hash;
    },

}